import React from "react";

const StartPayroll = ({ width, height }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 43.2 40.7"
    style={{ enableBackground: "new 0 0 43.2 40.7" }}
    width={width}
    height={height}
  >
    <g>
      <path
        className="st1"
        d="M16,19.5c0,0.5,0.4,1,1,1H32c0.5,0,1-0.4,1-1s-0.4-1-1-1H16.9C16.4,18.5,16,19,16,19.5z"
      />
      <path
        className="st1"
        d="M32,22.8H16.9c-0.5,0-1,0.4-1,1c0,0.5,0.4,1,1,1H32c0.5,0,1-0.4,1-1C33,23.3,32.6,22.8,32,22.8z"
      />
      <path
        className="st1"
        d="M32,27.2H16.9c-0.5,0-1,0.4-1,1c0,0.5,0.4,1,1,1H32c0.5,0,1-0.4,1-1C33,27.6,32.6,27.2,32,27.2z"
      />
      <path
        className="st1"
        d="M23.6,15.1v0.3c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9v-0.3c1.5-0.2,2.3-1.2,2.3-2.5c0-1.9-1.6-2.4-2.8-2.8c-0.8-0.3-1.3-0.5-1.3-0.8c0-0.5,0.6-0.5,0.9-0.5c0.6,0,1.1,0.3,1.3,0.5c0.8,0.7,1.7,0.2,1.7-0.6c0-0.2-0.1-0.4-0.2-0.6c-0.4-0.5-1.1-0.9-1.9-1.1V6.4c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v0.3C22.1,7,21.6,8,21.6,9c0,1.8,1.5,2.3,2.7,2.7c0.9,0.3,1.4,0.5,1.4,0.9c0,0.2-0.1,0.3-0.1,0.4c-0.2,0.2-0.5,0.2-1,0.2c-0.6,0-1.1-0.2-1.6-0.7c-0.1-0.1-0.4-0.4-0.8-0.4c-0.5,0-1,0.4-1,1c0,0.2,0.1,0.4,0.1,0.5C21.8,14.3,22.7,14.9,23.6,15.1z"
      />
      <path
        className="st1"
        d="M42,0.6L42,0.6c-0.3-0.1-0.8-0.1-1.1-0.1L19,0.5c-4.5,0-8.1,3.6-8.1,8.1l0,22.4H1.5c-0.5,0-1,0.4-1,1c0,4.5,3.6,8.1,8.1,8.1H29l0.1,0l0.1,0c0.1,0,0.1,0,0.2,0c4.5,0,8.1-3.6,8.1-8.1V8.6c0-2.5,2.4-5.1,4.6-6c0.3-0.1,0.6-0.6,0.6-1C42.6,1.1,42.4,0.8,42,0.6z M8.7,38.1c-3,0-5.6-2.2-6-5.1h18.7c0.2,2,1.2,3.8,2.7,5.1H8.7z M35.4,8.6V32c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1c0-0.5-0.4-1-1-1h-9.3l0-22.4c0-3.4,2.7-6.1,6.1-6.1l19.4,0C36.6,4.2,35.4,6.5,35.4,8.6z"
      />
    </g>
  </svg>
);
export default StartPayroll;
